import React from 'react'
import socketio from 'socket.io-client'
import Config from '../../config.json'

export const socket = socketio.connect(Config.BASE_URL)
export const SocketContext = React.createContext()
